<template>
  <v-dialog 
    v-model="navigation.insertCRMWhatsappConversationDialogIsVisible" 
    @update:model-value="navigation.insertCRMWhatsappConversationDialogIsVisible == false ? closeInsertCRMWhatsappConversationDialog() : null" 
    :max-width="$vuetify.display.mobile ? '90vw' : '50vw'"
    @contextmenu.prevent="null"
    style="user-select: none; cursor: default;"
  >
    <v-card style="max-height: 90vh; display: flex; flex-direction: column;">
      <div style="position: sticky; top: 0; z-index: 10; background: white;">
        <v-card color="primary" rounded="0" elevation="0" class="headerCard">
          <div class="titleContainer">
            <v-icon color="indigo" size="large">mdi-chat</v-icon>
            <v-icon color="indigo" size="small" style="margin-right: 10px;">mdi-plus-circle</v-icon>
            <p class="titleText">AGREGAR CONVERSACIÓN</p>
          </div>
          <div class="actionsContainer">
            <v-btn 
              @click="closeInsertCRMWhatsappConversationDialog()"
              :disabled="loader.getSystemInformationData || loader.insertCRMWhatsappConversationFromInsertCRMWhatsappConversationDialog"
              color="error" 
              class="hoverableText" 
            >
              <v-icon style="margin-right: 10px;">mdi-close-circle</v-icon>
              <p>CERRAR</p>
            </v-btn>
          </div>
        </v-card>
        <v-card color="indigo" elevation="0" rounded="0" style="width: 100%; height: 2px;"></v-card>
      </div>    
      <div style="padding: 15px;">
        <template v-if="navigation.CRMWhatsappConversation">
          <div style="display: flex; align-items: center; gap: 10px;">
            <p>La conversación <strong>{{ navigation.CRMWhatsappConversation.CRMWhatsappConversationID }}</strong> con el contacto <strong>{{ $displayFunctions.default.parseCRMWhatsappContactNameToDisplay(navigation.CRMWhatsappConversation) }}</strong> está activa en este momento con el agente
              <span>
                <template v-if="systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == navigation.CRMWhatsappConversation.CRMWhatsappConversationCurrentCRMAgentID)">
                  <v-chip :color="systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == navigation.CRMWhatsappConversation.CRMWhatsappConversationCurrentCRMAgentID).CRMAgentColor || 'primary'" variant="flat" elevation="2" label>
                    <div style="display: flex; align-items: center;">
                      <img :src="systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == navigation.CRMWhatsappConversation.CRMWhatsappConversationCurrentCRMAgentID).CRMAgentProfilePictureURL || require('@/assets/images/CRMAgentProfilePicturePlaceholder.png')" draggable="false" style="width: 30px; height: 30px; border-radius: 50%; object-fit: cover; margin-right: 10px;">
                      <p>{{ systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == navigation.CRMWhatsappConversation.CRMWhatsappConversationCurrentCRMAgentID).CRMAgentName || 'No registrado' }}</p>
                    </div>
                  </v-chip>
                </template>
                <template v-else>
                  <v-chip color="primary" variant="flat" elevation="2" label>
                    <div style="display: flex; align-items: center;">
                      <img :src="require('@/assets/images/CRMAgentProfilePicturePlaceholder.png')" draggable="false" style="width: 30px; height: 30px; border-radius: 50%; object-fit: cover; margin-right: 10px;">
                      <p>No registrado</p>
                    </div>
                  </v-chip>
                </template>
              </span>
              . Es necesario transferirla o cerrarla antes de agregar la conversación por este medio
            </p>
          </div>
        </template>
        <template v-else>
          <div class="twoColumnContainer">
            <v-autocomplete
              v-model="input.CRMWhatsappContactPhoneNumberCode"
              :items="$assets.default.countryCodePhoneNumberOptions"
              :loading="loader.getSystemInformationData || loader.insertCRMWhatsappConversationFromInsertCRMWhatsappConversationDialog"
              :disabled="loader.getSystemInformationData || loader.insertCRMWhatsappConversationFromInsertCRMWhatsappConversationDialog"
              prepend-inner-icon="mdi-barcode"
              variant="outlined"
              density="compact"
              autocomplete="off"
              item-title="metadata"
              item-value="code"
              label="Código de país"
              chips
              closable-chips
              hide-no-data
              hide-details
              clearable
            >
              <template v-slot:chip="{ item }">
                <v-chip color="primary" variant="flat" elevation="2" label>
                  <div style="display: flex; align-items: center; gap: 5px;">
                    <p>{{ item.raw.flag }}</p>
                    <p>{{ item.raw.shortName }}</p>
                    <p>(+{{ item.raw.code }})</p>
                  </div>
                  <template v-slot:close>
                    <v-icon 
                      size="smaller"
                      class="hoverableElement"
                      @click.stop="input.CRMWhatsappContactPhoneNumberCode = null; $generalFunctions.default.blurInput(this, 'CRMWhatsappContactPhoneNumberCode');"
                    >
                      mdi-close-circle
                    </v-icon>
                  </template>
                </v-chip>
              </template>
              <template v-slot:item="{ props, item }">
                <v-list density="compact" style="overflow: hidden; padding: 0; margin: 0;">
                  <v-list-item 
                    v-bind="props" 
                    :title="null" 
                    :subtitle="null"
                    :active="input.CRMWhatsappContactPhoneNumberCode == item.value"
                    class="hoverableText"
                    style="padding-top: 5px; padding-bottom: 5px;"
                  >
                    <template v-slot:prepend>
                      <v-checkbox-btn 
                        :model-value="input.CRMWhatsappContactPhoneNumberCode == item.value" 
                        density="compact" 
                        hide-details 
                        readonly
                        class="hoverableElement"
                        style="margin-right: 10px;"
                      ></v-checkbox-btn>
                    </template>
                    <div style="display: flex; align-items: center; gap: 10px;">
                      <p>{{ item.raw.flag }}</p>
                      <p>{{ item.raw.name }}</p>
                      <p>(+{{ item.raw.code }})</p>
                    </div>
                  </v-list-item>
                </v-list>
              </template>
            </v-autocomplete>
            <v-text-field
              ref="CRMWhatsappContactPhoneNumber"
              v-model="input.CRMWhatsappContactPhoneNumber" 
              @keypress="$generalFunctions.default.allowOnlyNumberOnInput($event)"
              :loading="loader.getSystemInformationData || loader.insertCRMWhatsappConversationFromInsertCRMWhatsappConversationDialog"
              :disabled="loader.getSystemInformationData || loader.insertCRMWhatsappConversationFromInsertCRMWhatsappConversationDialog"
              prepend-inner-icon="mdi-phone"
              label="Número de teléfono" 
              variant="outlined" 
              density="compact"
              autocomplete="off"
              hide-details
              clearable
            ></v-text-field>
          </div>
          <v-text-field
            v-model="input.CRMWhatsappContactFirstName"
            :loading="loader.getSystemInformationData || loader.insertCRMWhatsappConversationFromInsertCRMWhatsappConversationDialog"
            :disabled="loader.getSystemInformationData || loader.insertCRMWhatsappConversationFromInsertCRMWhatsappConversationDialog"
            @keydown.enter.prevent="insertCRMWhatsappConversationFromInsertCRMWhatsappConversationDialog()"
            label="Nombre del contacto (opcional)"
            prepend-inner-icon="mdi-account"
            variant="outlined"
            density="compact"
            autocomplete="off"
            clearable
            hide-details
            style="margin-top: 15px;"
          ></v-text-field>
          <v-textarea
            v-model="input.CRMWhatsappConversationNoteContent"
            :loading="loader.getSystemInformationData || loader.insertCRMWhatsappConversationFromInsertCRMWhatsappConversationDialog"
            :disabled="loader.getSystemInformationData || loader.insertCRMWhatsappConversationFromInsertCRMWhatsappConversationDialog"
            @keydown.enter.prevent="insertCRMWhatsappConversationFromInsertCRMWhatsappConversationDialog()"
            label="Nota de la conversación (opcional)"
            prepend-inner-icon="mdi-note"
            variant="outlined"
            density="compact"
            autocomplete="off"
            rows="3"
            max-rows="5"
            auto-grow
            clearable
            hide-details
            style="margin-top: 15px;"
          ></v-textarea>
        </template>
      </div>
      <v-card color="indigo" elevation="0" rounded="0" style="width: 100%; height: 2px;"></v-card>
      <v-card color="primary" elevation="0" rounded="0" style="padding: 15px;">
        <template v-if="navigation.CRMWhatsappConversation">
          <v-btn 
            @click="input.CRMWhatsappContactPhoneNumber = 506; input.CRMWhatsappContactFirstName = null; input.CRMWhatsappConversationNoteContent = null; navigation.CRMWhatsappConversation = null;" 
            color="secondary" 
            block 
            class="hoverableText"
          >
            <v-icon style="margin-right: 10px;">mdi-arrow-left-circle</v-icon>
            <h3>REGRESAR</h3>
          </v-btn>
        </template>
        <template v-else>
          <v-tooltip :disabled="validateInputForInsertCRMWhatsappConversationDialog(false).success || loader.insertCRMWhatsappConversationFromInsertCRMWhatsappConversationDialog" :text="validateInputForInsertCRMWhatsappConversationDialog(false).result" location="top"> 
            <template v-slot:activator="{ props }">
              <div v-bind="props">
                <v-btn 
                  @click="validateInputForInsertCRMWhatsappConversationDialog(true).success ? insertCRMWhatsappConversationFromInsertCRMWhatsappConversationDialog() : null" 
                  :disabled="!validateInputForInsertCRMWhatsappConversationDialog(false).success || loader.getSystemInformationData || loader.insertCRMWhatsappConversationFromInsertCRMWhatsappConversationDialog" 
                  color="indigo" 
                  block 
                  class="hoverableText"
                >
                  <v-icon size="large">mdi-chat</v-icon>
                  <v-icon size="small" style="margin-right: 10px;">mdi-plus-circle</v-icon>
                  <p class="titleText">AGREGAR CONVERSACIÓN</p>
                </v-btn>
              </div>
            </template>
            <span style="max-width: 400px; display: block;">{{ validateInputForInsertCRMWhatsappConversationDialog(false).result }}</span>
          </v-tooltip>
        </template>
      </v-card>
   </v-card>
  </v-dialog>
</template>
  
<style scoped>
  .headerCard {
    padding: 15px;
    display: grid;
    justify-content: center;
    align-items: center;
    gap: 10px;
    grid-template-columns: repeat(2, 1fr);
  }
  .titleContainer {
    display: flex;
    align-items: center;
  }
  .titleText {
    font-size: large;
    font-weight: bold;
  }
  .actionsContainer {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-left: auto;
  }
  .twoColumnContainer {
    display: grid;
    grid-template-columns: 0.4fr 0.6fr;
    gap: 15px;
    align-items: center;
  }
  @media (max-width: 1200px) {
    .headerCard {
      grid-template-columns: 1fr;
    }
    .titleContainer {
      justify-content: center;
    }
    .titleText {
      font-size: medium;
    }
    .actionsContainer {
      justify-content: center;
      margin-left: 0;
    }
    .twoColumnContainer {
      grid-template-columns: 1fr;
    }
  }
</style>

<script>
  import { systemInformation } from '@/utilities/systemInformation';
  export default {
    inject: ['$generalFunctions', '$displayFunctions', '$assets'],
    data: () => 
    ({
      input: 
      {
        CRMWhatsappContactPhoneNumberCode: '506',
        CRMWhatsappContactPhoneNumber: null,
        CRMWhatsappContactFirstName: null,
        CRMWhatsappConversationNoteContent: null
      },
      display: 
      {
        CRMWhatsappConversation: null
      },
      navigation: 
      {
        insertCRMWhatsappConversationDialogIsVisible: false,
        CRMWhatsappConversation: null
      },
      loader: 
      {
        getSystemInformationData: false,
        insertCRMWhatsappConversationFromInsertCRMWhatsappConversationDialog: false
      },
      systemInformationData: 
      {
        CRMAccountID: null,
        CRMAgent: null,
        CRMAgents: [],
        tooltipDisabled: false,
        updateSubscription: null
      }
    }),
    
    methods:
    {
      async insertCRMWhatsappConversationFromInsertCRMWhatsappConversationDialog(){
        this.loader.insertCRMWhatsappConversationFromInsertCRMWhatsappConversationDialog = true;
        const insertCRMWhatsappConversationFromInsertCRMWhatsappConversationDialogRequestQuery = 
        {
          'localStorage':
          {
            'CRMAccountID': this.systemInformationData.CRMAccountID,
            'CRMAgentID': this.systemInformationData.CRMAgent.CRMAgentID,
          },
          'CRMWhatsappContactPhoneNumber': `${this.input.CRMWhatsappContactPhoneNumberCode}${this.input.CRMWhatsappContactPhoneNumber}`,
          'CRMWhatsappContactFirstName': this.input.CRMWhatsappContactFirstName,
          'CRMWhatsappConversationNoteContent': this.input.CRMWhatsappConversationNoteContent
        };
        const insertCRMWhatsappConversationFromInsertCRMWhatsappConversationDialogResult = await this.$generalFunctions.default.executeHttpPOSTRequest('/CRMWhatsappConversation/functions/insertCRMWhatsappConversationFromInsertCRMWhatsappConversationDialog', insertCRMWhatsappConversationFromInsertCRMWhatsappConversationDialogRequestQuery);
        if (insertCRMWhatsappConversationFromInsertCRMWhatsappConversationDialogResult.success){
          this.$root.notificationDialog.showSystemNotificationDialog('insertCRMWhatsappConversationFromInsertCRMWhatsappConversationDialog_success', 'success', `La conversación con el contacto ${this.$displayFunctions.default.fromPhoneNumberToCountryCodePhoneNumberCountryFlag(this.input.CRMWhatsappContactPhoneNumber, false)} ha sido agregada`, null, true);
          this.closeInsertCRMWhatsappConversationDialog();
        } else {
          if (insertCRMWhatsappConversationFromInsertCRMWhatsappConversationDialogResult.result.CRMWhatsappConversation){
            this.navigation.CRMWhatsappConversation = insertCRMWhatsappConversationFromInsertCRMWhatsappConversationDialogResult.result.CRMWhatsappConversation;
          } else {
            this.$root.notificationDialog.showSystemNotificationDialog('insertCRMWhatsappConversationFromInsertCRMWhatsappConversationDialog_error', 'error', `Ha ocurrido un error inesperado al agregar la conversación con el contacto ${this.$displayFunctions.default.fromPhoneNumberToCountryCodePhoneNumberCountryFlag(this.input.CRMWhatsappContactPhoneNumber, false)}, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema`, null, true);
          }
        }
        this.loader.insertCRMWhatsappConversationFromInsertCRMWhatsappConversationDialog = false;
      },

      validateInputForInsertCRMWhatsappConversationDialog(showSystemNotificationDialog){
        const regularExpressionChecker = /\S/;
        if (this.input.CRMWhatsappContactPhoneNumber == null || !regularExpressionChecker.test(this.input.CRMWhatsappContactPhoneNumber)){
          if (showSystemNotificationDialog) this.$root.notificationDialog.showSystemNotificationDialog('validateInputForInsertCRMWhatsappConversationDialog_missingCRMWhatsappContactPhoneNumber', 'warning', 'El número de teléfono del contacto es obligatorio', null, false);
          return {success: false, result: 'El número de teléfono del contacto es obligatorio'};
        } else if (this.input.CRMWhatsappContactPhoneNumber.length > 30){
          if (showSystemNotificationDialog) this.$root.notificationDialog.showSystemNotificationDialog('validateInputForInsertCRMWhatsappConversationDialog_CRMWhatsappContactPhoneNumberTooLong', 'warning', 'El número de teléfono del contacto no puede exceder los 30 caracteres', null, false);
          return {success: false, result: 'El número de teléfono del contacto no puede exceder los 30 caracteres'};
        } else if (this.input.CRMWhatsappContactFirstName != null && this.input.CRMWhatsappContactFirstName.length > 100){
          if (showSystemNotificationDialog) this.$root.notificationDialog.showSystemNotificationDialog('validateInputForInsertCRMWhatsappConversationDialog_CRMWhatsappContactFirstNameTooLong', 'warning', 'El nombre del contacto no puede exceder los 100 caracteres', null, false);
          return {success: false, result: 'El nombre del contacto no puede exceder los 100 caracteres'};
        } else if (this.input.CRMWhatsappConversationNoteContent != null && this.input.CRMWhatsappConversationNoteContent.length > 65535){
          if (showSystemNotificationDialog) this.$root.notificationDialog.showSystemNotificationDialog('validateInputForInsertCRMWhatsappConversationDialog_CRMWhatsappConversationNoteContentTooLong', 'warning', 'La nota de la conversación no puede exceder los 65535 caracteres', null, false);
          return {success: false, result: 'La nota de la conversación no puede exceder los 65535 caracteres'};
        }
        return {success: true, result: null};
      },

      async getSystemInformationData(){
        this.loader.getSystemInformationData = true;
        try {
          systemInformation.setGeneralFunctions(this.$generalFunctions.default);
          const systemInformationResult = await systemInformation.startup();
          if (systemInformationResult.success){
            this.systemInformationData.CRMAccountID = systemInformation.getCRMAccountID;
            this.systemInformationData.CRMAgent = systemInformation.getCRMAgent;
            this.systemInformationData.CRMAgents = systemInformation.getCRMAgents;
            this.systemInformationData.tooltipDisabled = systemInformation.getTooltipDisabled;
            this.systemInformationData.updateSubscription = systemInformation.subscribeToUpdate((updatedSystemInformationData) => {
              this.systemInformationData.tooltipDisabled = updatedSystemInformationData.tooltipDisabled;
            });
          } else {
            this.$root.notificationDialog.showSystemNotificationDialog('getSystemInformation_error', 'error', 'Ha ocurrido un error inesperado al obtener la información del sistema, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, false);
            this.closeInsertCRMWhatsappConversationDialog();
          }
        } catch {
          this.$root.notificationDialog.showSystemNotificationDialog('getSystemInformation_error', 'error', 'Ha ocurrido un error inesperado al obtener la información del sistema, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, false);
          this.closeInsertCRMWhatsappConversationDialog();
        }
        this.loader.getSystemInformationData = false;
      },
      
      async openInsertCRMWhatsappConversationDialog(){
        this.input.CRMWhatsappContactPhoneNumberCode = '506';
        this.input.CRMWhatsappContactPhoneNumber = null;
        this.input.CRMWhatsappContactFirstName = null;
        this.input.CRMWhatsappConversationNoteContent = null;
        this.display.CRMWhatsappConversation = null;
        this.loader.insertCRMWhatsappConversationFromInsertCRMWhatsappConversationDialog = false;
        this.navigation.CRMWhatsappConversation = null;
        this.navigation.insertCRMWhatsappConversationDialogIsVisible = true;
        await this.getSystemInformationData();
        this.$generalFunctions.default.focusInput(this, 'CRMWhatsappContactPhoneNumber');
      },

      closeInsertCRMWhatsappConversationDialog(){
        this.navigation.insertCRMWhatsappConversationDialogIsVisible = false;
        if (this.systemInformationData.updateSubscription) systemInformation.unsubscribeFromUpdate(this.systemInformationData.updateSubscription);
        this.systemInformationData.updateSubscription = null;
        this.$emit('closeInsertCRMWhatsappConversationDialog');
      }
    }
  }
</script>